import ProfileListPageReducer from './ProfileListPageReducer';

export default from './ProfileListPageContainer';

export const ProfileListPageReducers = {
  ProfileListPageReducer,
};
